import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
import { Section } from './ui/Section';
const faqs = [{
  q: '¿Está realmente alineado al Programa EBI de ANEP?',
  a: 'Sí. Todo el material fue desarrollado tomando como base el Programa de Educación Básica Integrada vigente, específicamente el Tramo 2. Las planificaciones, secuencias didácticas y evaluaciones responden a los descriptores, orientaciones y unidades curriculares oficiales de ANEP.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después del pago recibís un enlace de descarga directo por email. En menos de 5 minutos tenés los 6 tomos y los 6 bonos en tu dispositivo, listos para usar el mismo día.'
}, {
  q: '¿Lo puedo imprimir?',
  a: 'Sí. Todos los PDFs están optimizados para impresión en A4. Podés imprimir solo las fichas que necesitás, en el momento que las necesitás. Sin desperdiciar papel ni tinta.'
}, {
  q: '¿Qué lo diferencia del material que circula en grupos de WhatsApp o en internet?',
  a: 'El material gratuito que circula en grupos no tiene secuencia pedagógica, no está articulado entre áreas y raramente está alineado al EBI real. Aula de Éxitos es un sistema completo: planificación + ficha de alumno + evaluación + rúbrica, todo coherente, todo alineado, todo en un solo lugar. No es una carpeta de fichas sueltas. Es un año de clases resuelto.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días, devolución completa, sin preguntas. Podés usarlo en el aula esta semana y si no es lo que esperabas, te devolvemos el 100% del dinero.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section background="cream" data-id="element-51">
      <div className="max-w-3xl mx-auto" data-id="element-52">
        <div className="text-center mb-12" data-id="element-53">
          <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900" data-id="element-54">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-4" data-id="element-55">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-2xl shadow-sm border border-stone-200 overflow-hidden" data-id="element-56">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-celeste-500" aria-expanded={openIndex === idx} data-id="element-57">
                <span className="font-bold text-stone-800 pr-4" data-id="element-58">{faq.q}</span>
                <span className="text-celeste-600 shrink-0" data-id="element-59">
                  {openIndex === idx ? <Minus className="w-5 h-5" data-id="element-60" /> : <Plus className="w-5 h-5" data-id="element-61" />}
                </span>
              </button>

              <AnimatePresence data-id="element-62">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-63">
                    <div className="px-6 pb-5 text-stone-600 font-medium leading-relaxed border-t border-stone-50 pt-4" data-id="element-64">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
};